import React, { useEffect, useState, Fragment } from 'react'
import {
  withStyles,
  CircularProgress,
  Typography,
  Menu,
  MenuItem,
  Link,
  Fade,
  Snackbar,
  SnackbarContent,
  Select,
  InputBase,
  Checkbox,
} from '@material-ui/core'
import SvgIcon from '@material-ui/core/SvgIcon'
import Cookies from 'js-cookie'
import { Telegram, Warning } from '@material-ui/icons'
import Stats from './Stats'
import DayPicker from '../calendar/DayPicker'
import moment from 'moment'
import RoiExcel from './RoiExcel'
import RoiTable from './RoiTable'
import AskReport from '../AskReport'
import PageHeader from '../PageHeader'

const dateFormat = "YYYY-MM-DD"

const BoomIcon = (props) => {
  return (
    <SvgIcon {...props}>
      <path d="M10 2H4C2.9 2 2 2.9 2 4S2.9 6 4 6H8L10 2M18 2C20.2 2 22 3.8 22 6V12L18 14C18 9.6 14.4 6 10 6L12 2H18M18 20V16L22 14V20C22 21.1 21.1 22 20 22S18 21.1 18 20Z" />
    </SvgIcon>
  )
}

const StyledInput = withStyles((theme) => ({
  input: {
    borderRadius: 8,
    overflowX: 'auto',
    position: 'relative',
    padding: '2px 5px 2.5px 5px',
    border: '1px solid #fff',
    color: "#fff",
    fontSize: 7,
    '&:focus': {
      border: '1px solid',
      borderRadius: 8,
      borderColor: '#25aae1',
      backgroundColor: 'transparent',
    }
  },
}))(InputBase)

const StyledInputLT = withStyles((theme) => ({
  input: {
    borderRadius: 8,
    overflowX: 'auto',
    position: 'relative',
    padding: '2px 5px 2.5px 5px',
    border: '1px solid #6e6e6e',
    color: "#6e6e6e",
    fontSize: 7,
    '&:focus': {
      border: '1px solid',
      borderRadius: 8,
      borderColor: '#25aae1',
      backgroundColor: 'transparent',
    }
  },
}))(InputBase)

const RoiMain = (props) => {
  const {pageName} = props
  const darkMode = JSON.parse(localStorage.getItem("darkMode")) !== null ? JSON.parse(localStorage.getItem("darkMode")) : true
  const token = Cookies.get("token")
  const usr = JSON.parse(localStorage.getItem("currentUser")) ? JSON.parse(localStorage.getItem("currentUser"))[0] : null
  const endpointRoot = pageName === "Boomerang" ? "boomROI" : "triggerROI"
  const maxDate =
    pageName === "Boomerang"
      ? (usr?.max_date_boom ? moment(usr.max_date_boom) : moment())
      : (usr?.max_date_trig ? moment(usr.max_date_trig) : moment())

  const initialEndDate = maxDate
  const initialStartDate = maxDate.clone().startOf("year").subtract(1, "years")

  const [dates, setDates] = useState({ minyearmo: initialStartDate, maxyearmo: initialEndDate })
  const [days, setDays] = useState(0)
  const defaultCompleted = [173, 315, 393]
  const [selectedRoiData, setSelectedRoiData] = useState(null)
  const [mailingType, setMailingType] = useState("complete")
  const [checkList, setCheckList] = useState([])    
  const [locType, setLocType] = useState("market")
  const [selectedMarkets, setSelectedMarkets] = useState([])
  const [mailingTypeOpen, setMailingTypeOpen] = useState(false)
  const [anchor, setAnchor] = useState(null)  
  // const completeIDs = [304, 173, 328, 423, 122, 315, 393, 438, 273, 372, 394, 356, 368, 403, 424, 422, 131, 407, 388, 440, 350, 411, 355, 371, 359, 369]
  const [roiData, setRoiData] = useState(null)
  const [snackbar, setSnackbar] = useState(false)
  const [message, setMessage] = useState("")
  const [hasData, setHasData] = useState(false)
  const [marketLoading, setMarketLoading] = useState(true)

  const getRoiData = (props) => {        
    const {requestDates, requestCompleted, requestLocType} = props
    let category = endpointRoot === "boomROI" ? "category" : "trigType"

    let dataArr = []   
    
    setMarketLoading(true)

    fetch('/config.json')
      .then(response => response.json())
      .then(config => {
        console.log("DEBUGGG", config.apiUrl); // use the api URL
      });
  
    console.log("DEBUG requestCompleted", requestCompleted)

    const request = Promise.all([
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${endpointRoot}?startDate=${requestDates[0].format(dateFormat)}&endDate=${requestDates[1].format(dateFormat)}&complete=${requestCompleted}`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${endpointRoot}/custPros?startDate=${requestDates[0].format(dateFormat)}&endDate=${requestDates[1].format(dateFormat)}&complete=${requestCompleted}`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${endpointRoot}/${category}?startDate=${requestDates[0].format(dateFormat)}&endDate=${requestDates[1].format(dateFormat)}&complete=${requestCompleted}`, {headers: {token: token}}),            
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${endpointRoot}/dashboard/${requestLocType}?startDate=${requestDates[0].format(dateFormat)}&endDate=${requestDates[1].format(dateFormat)}&complete=${requestCompleted}`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${endpointRoot}/dashboard?startDate=${requestDates[0].format(dateFormat)}&endDate=${requestDates[1].format(dateFormat)}&complete=${requestCompleted}`, {headers: {token: token}}),
      fetch(`https://api.v2.smartdash.com/smartdash-dev/v1/index.cfm/${endpointRoot}/${endpointRoot === "boomROI" ? "listType" : "trigType"}?startDate=${requestDates[0].format(dateFormat)}&endDate=${requestDates[1].format(dateFormat)}&complete=${requestCompleted}`, {headers: {token: token}}),
    ])
    
    request.then(([response, response2, response3, response4, response5, response6]) => Promise.all([response.json(), response2.json(), response3.json(), response4.json(), response5.json(), response6.json()]))
    .then(([data, data2, data3, data4, data5, data6]) => {      
      if(data.length > 0) {
        let dataObj = {}                
        dataObj[`Data_${category.charAt(0).toUpperCase() + category.slice(1)}`] = data3
        dataObj["Data_CustPros"] = data2
        dataObj["Data_Location"] = data5[0].Data_Location
        dataObj["Data_ListType"] = data6
        dataObj["Data_Overall"] = data[0].Data               
        dataObj["Label"] = "ALL"
        dataObj["Key"] = data4.length + 1
        dataArr.push(dataObj)    
                
        setRoiData(dataArr.concat(data4))        
        setDays(initialEndDate.diff(initialStartDate, "days"))
        setCheckList(dataArr.concat(data4).map(({Label}) => Label))
        setMailingType(requestCompleted === 1 ? "complete" : "all")
        setHasData(true)
        setMarketLoading(false)        
        
        if(selectedMarkets.length < 1 || selectedMarkets.length === checkList.length) {
          setSelectedMarkets(dataArr.concat(data4).map(({Label}) => Label))
          setSelectedRoiData(dataArr)
        } else {
          setSelectedMarkets(dataArr.concat(data4).map(({Label}) => Label).filter(item => selectedMarkets.includes(item)))
          setSelectedRoiData(dataArr.concat(data4).filter(({Label}) => selectedMarkets.includes(Label)))          
        }
      } else if(data.length < 1 && !hasData) {
        setRoiData([])
        setSelectedRoiData([])
      } else {
        setMarketLoading(false)
        setSnackbar(true)
        setMessage(`${pageName} ROI is not available for the selected options. Please broaden your search and try again`)
        setRoiData([])
        setSelectedRoiData([])
      }
    })
    .catch(error => {
      console.log(error)
    })
  }

  useEffect(() => getRoiData({requestDates: [initialStartDate, initialEndDate], requestCompleted: usr.roi_all_mailings_default === 0 ? 1 : 0, requestLocType: locType}), [])
    
  const getStatsData = () => {    
    let overall = selectedRoiData.map(({Data_Overall}) => Data_Overall[0])
    let total = overall.reduce((a,b) => {
      for(const prop in b) {
        if(a.hasOwnProperty(prop)) a[prop] += b[prop]
        else a[prop] = b[prop]
      }
      return a
    }, {})
    
    return total
  }

  const handleMarketChange = (e) => {  
    const {value} = e.target  

    console.log(value)
    
    let data = [...roiData]    
    let newChecked = [...selectedMarkets]    
    let totalsArr = []
    let totalsObj = {}
    let selectedData = pageName === "Boomerang" ?
      locType === "market" ?
      {Data_Overall:[], Data_CustPros: [], Data_Category: [], Data_Location: [], Data_ListType: []}
    :
      {Data_Overall:[], Data_CustPros: [], Data_Category: [], Data_ListType: []}
    : locType === "market" ?
      {Data_Overall:[], Data_CustPros: [], Data_TrigType: [], Data_Location: []}
    :
      {Data_Overall:[], Data_CustPros: [], Data_TrigType: []}
    
    
    const filterData = (newData) => {      
      for(let i = 0; i < newData.length; i++) {        
        for(let j = 0; j < Object.keys(selectedData).length; j++) {
          selectedData[Object.keys(selectedData)[j]].push(newData[i][Object.keys(selectedData)[j]])
        }          
      }

      for(let i = 0; i < Object.keys(selectedData).length; i++) {
        if(selectedData[Object.keys(selectedData)[i]][0].length > 1) {          
          let dataName = Object.keys(selectedData)[i]          
          let labels = selectedData[dataName][0].map(({Label}) => Label)            
          let arr = []

          for(let j = 0; j < labels.length; j++) {
            let obj = {}
            obj["label"] = labels[j]
            obj["data"] = []
            
            for(let k = 0; k < selectedData[dataName].length; k++) {                                                
              obj["data"].push(selectedData[dataName][k].filter(({Label}) => Label === labels[j])[0])
            }                          
            arr.push(obj)              
          }          
                      
          let totalsData = arr.map(({data}) => data.reduce((a,b) => {
            for(const prop in b) {
              if(a.hasOwnProperty(prop) && prop !== "Label") a[prop] += b[prop]
              else a[prop] = b[prop]
            }
            return a
          }, {}))
          
          totalsObj[dataName] = totalsData                                  
        } else {
          let total = [selectedData[Object.keys(selectedData)[i]].map(arr => arr[0]).reduce((a,b) => {
            for(const prop in b) {
              if(a.hasOwnProperty(prop)) a[prop] += b[prop]
              else a[prop] = b[prop]
            }
            return a
          }, {})]  
          totalsObj[Object.keys(selectedData)[i]] = total            
        }
      }                                
      return totalsObj
    }
    
    if(selectedMarkets.length === checkList.length) {
      if(value.indexOf("ALL") === -1) {        
        newChecked = []
        totalsArr.push(selectedData)
      } else {        
        newChecked = value.filter(option => option !== "ALL")
        let newData = data.filter(({Label}) => Label !== "ALL" && value.includes(Label))        
        console.log(newData)
        let totals = filterData(newData)

        totalsArr.push(totals)        
      }      
      setSelectedMarkets(newChecked)
      setSelectedRoiData(totalsArr)
    } else if(selectedMarkets.length === 0) {
      if(value.indexOf("ALL") !== -1) {
        newChecked = checkList
        totalsArr = roiData.filter(({Label}) => Label == "ALL")           
      } else {        
        newChecked = value
        totalsArr = roiData.filter(({Label}) => Label === value[0])
      }
      setSelectedMarkets(newChecked)
      setSelectedRoiData(totalsArr)
    } else {
      if(value.indexOf("ALL") !== -1) {        
        newChecked = checkList
        totalsArr = roiData.filter(({Label}) => Label === "ALL")                
      } else if(value.length === checkList.filter(option => option !== "ALL").length) {                                        
        newChecked = checkList          
        totalsArr = roiData.filter(({Label}) => Label === "ALL")
      } else {        
        newChecked = value.filter(option => option !== "ALL")
        let newData = data.filter(({Label}) => Label !== "ALL" && value.includes(Label))        
        let totals = filterData(newData)        

        totalsArr.push(totals)                                    
      }      
      setSelectedMarkets(newChecked)
      setSelectedRoiData(totalsArr)      
    }        
  }      

  const handleSelectLocType = (e) => {
    const { value } = e.target
    let completeParam = mailingType === "complete" ? 1 : 0
          
    getRoiData({requestDates: [dates.minyearmo, dates.maxyearmo], requestCompleted: completeParam, requestLocType: value})
    setLocType(value)
  }

  const handleMailTypeMenu = (e) => {
    const { currentTarget } = e

    setMailingTypeOpen(true)
    setAnchor(currentTarget)
  }

  const handleMailTypeMenuClose = () => {
    setMailingTypeOpen(false)
    setAnchor(null)
  }

  const changeMailingType = (e) => {
    const {myValue} = e.currentTarget.dataset    
    let completeParam = myValue === "complete" ?  1 : 0   

    console.log('DEBUG called here', completeParam)
    getRoiData({requestDates: [dates.minyearmo, dates.maxyearmo], requestCompleted: completeParam, requestLocType: locType})
    setMailingType(myValue)    
  }

  const handleDateChange = (value, valName) => {    
    const completeParam = mailingType === "complete" ?  1 : 0    
  
    if(valName === "startDate") {
      getRoiData({requestDates: [value, dates.maxyearmo], requestCompleted: completeParam, requestLocType: locType})
      setDays(dates.maxyearmo.diff(value, "days"))
      setDates(prevState => ({...prevState, minyearmo: value}))     
    } else {                        
      getRoiData({requestDates: [dates.minyearmo, value], requestCompleted: completeParam, requestLocType: locType})
      setDays(dates.maxyearmo.diff(value, "days"))
      setDates(prevState => ({...prevState, maxyearmo: value}))      
    }
  }

  const handleSliderChange = (values) => {
    const min = values[0]
    const max = values[1]
    const completeParam = mailingType === "complete" ?  1 : 0
    
    getRoiData({requestDates: [moment(min), moment(max)], requestCompleted: completeParam, requestLocType: locType})
    setDays(moment(max).diff(moment(min), "days"))
    setDates(prevState => ({...prevState, minyearmo: moment(min), maxyearmo: moment(max)}))       
  }

  const handleSnackbarClose = (e, reason) =>  {
    if(reason === "clickaway") setSnackbar(false)

    setSnackbar(false)
  }

  if(!selectedRoiData) return <CircularProgress />
  if(!hasData) return <AskReport />

  const renderMarketSelectOptions = () => (      
    checkList.map((option, i) => (
      <MenuItem key={i} value={option}>
        <Checkbox
          edge="start"
          size="small"
          checked={selectedMarkets.indexOf(option) !== -1}
          disableRipple
          style={option === "ALL" ? {display: "none"} : {}}
        />
          <Typography variant="caption">
            {option === "ALL" ? checkList.length === selectedMarkets.length ? `DESELECT ${option.toUpperCase()} ${locType.toUpperCase()}` : `SELECT ${option.toUpperCase()} ${locType.toUpperCase()}` : option.toUpperCase()}
          </Typography>
      </MenuItem>
    ))
  )

  const renderRoiTables = () => {    
    const listDk = ['#00d2da', '#f2b000', '#85fa3e', '#ff7dae', '#ffa159', '#add449', '#92baf0', '#cfa895', '#ffbdf0']
    const listLt = ["#00bdc4", "#d99d00", "#58bd1a", "#cf3c73", "#eb8231", "#7ca318", "#db8c65", "#c270af"]
    const tables = pageName === "Boomerang" ?
      locType === "market" ? 
        [
          {title: "Customers vs Prospects", data: [], tableName: "CustPros", colorArr: darkMode ? ["#a3dbff", "#ffed75"] : ["#1fa7ff", "#d9a300"]},
          {title: "Product Categories", data: [], tableName: "Category", colorArr: darkMode ? listDk : listLt},
          {title: "List Types", data: [], tableName: "ListType", colorArr: darkMode ? ['#e6c7ff', '#ff968c'] : ["#ab42ff", "#ff6152"]},
          {title: "Locations", data: [], tableName: "Location"},
        ]
      :
        [
          {title: "Customers vs Prospects", data: [], tableName: "CustPros", colorArr: ["#a3dbff", "#ffed75"]},
          {title: "Product Categories", data: [], tableName: "Category", colorArr: darkMode ? listDk : listLt},
          {title: "List Types", data: [], tableName: "ListType", colorArr: darkMode ? ['#e6c7ff', '#ff968c'] : ["#ab42ff", "#ff6152"]},
        ]
    : 
      locType === "market" ?
        [
          {title: "Customers vs Prospects", data: [], tableName: "CustPros", colorArr: darkMode ? ["#a3dbff", "#ffed75"] : ["#1fa7ff", "#d9a300"]},
          {title: "Trigger Types", data: [], tableName: "TrigType", colorArr: darkMode ? listDk : listLt},        
          {title: "Locations", data: [], tableName: "Location"},
        ]
      :
        [
          {title: "Customers vs Prospects", data: [], tableName: "CustPros", colorArr: ["#a3dbff", "#ffed75"]},
          {title: "Trigger Types", data: [], tableName: "TrigType", colorArr: darkMode ? listDk : listLt},    
        ]          
        
    for(let i = 0; i < tables.length; i++) {      
      tables[i].data = selectedRoiData.length > 0 && selectedRoiData[0][`Data_${tables[i].tableName}`].length > 0 ? selectedRoiData[0][`Data_${tables[i].tableName}`] : []
    }

    function formatDate(dateStr) {
      if (!dateStr) return "N/A";
      const date = new Date(dateStr);
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", 
                  "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

      const day = date.getUTCDate().toString().padStart(2, '0');
      const month = months[date.getUTCMonth()];
      const year = date.getUTCFullYear();

      return `${month} ${day}, ${year}`;
    }
      
    return (
      <Fragment>
        {tables.map(({title, data, tableName, colorArr}) => (
          <Fragment key={tableName}>
            <Fade in={true}>
              <RoiTable 
                title={title}
                data={data.length > 0 ? data : []}
                tableName={tableName}
                colors={colorArr}
                dark={darkMode}
              />
            </Fade>
            <div style={{marginBottom: "35px"}} />                        
          </Fragment>
        ))}
        <Typography variant="subtitle1" style={{color: darkMode ? "lightgray" : "black"}}>** Data has been updated through: {formatDate(selectedRoiData?.[0]?.Data_Overall?.[0]?.MaxWrittenDate)} **</Typography>

      </Fragment>
    )
  }
    
  return (
    <div className="roi-page">
      <Snackbar
        open={snackbar}
        autoHideDuration={4500}
        onClose={handleSnackbarClose}
        anchorOrigin={{vertical: "top", horizontal: "center"}}
      >
        <SnackbarContent 
          message={<Typography style={{display: "flex", alignItems: "center", fontWeight: "bold"}}><Warning style={{marginRight: "10px"}}/>{message}</Typography>}
          style={{backgroundColor: "#de8400"}}
        />
      </Snackbar>
      <div className="roi-header">            
        <div>
          <PageHeader 
            details={{
              icon: pageName === "Boomerang" ? <BoomIcon style={{fontSize: "15px"}}/> : <Telegram style={{fontSize: "16px"}}/>,
              title: pageName
            }}
          />          
          {pageName === "Boomerang" ? 
            <Typography variant="caption" style={{fontSize: '12px', width: 100, color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>
              VIEW BOOMERANG LOST OPPORTUNITY <Link href={'/boomerang/lost-opportunity'} className="roi-toggle">HERE</Link>
            </Typography>
          : null
          }
        </div>        
        
        <div className="roi-filters">
          {marketLoading ? <div /> :
            <div style={{marginRight: "15px"}}>
              <RoiExcel 
                pageName={pageName}
                markets={selectedMarkets.filter(item => item !== "ALL")}
                selectedType={locType}
                startDate={dates.minyearmo}
                endDate={dates.maxyearmo}
                selectedData={selectedRoiData[0]}
                dark={darkMode}
              />
            </div>
          }
                              
          <Select
            variant="outlined"
            value={locType}
            onChange={handleSelectLocType}
            input={darkMode ? <StyledInput /> : <StyledInputLT />}
            MenuProps={{
              anchorOrigin: {vertical: "bottom", horizontal: "left"},
              transformOrigin: {vertical: "top", horizontal: "left"},
              getContentAnchorEl: null
            }}
            style={{marginRight: "15px", textAlign: "left", width: "150px"}}            
          >
            <MenuItem value={"market"}><div style={{padding: "5px 15px 0px 20px"}}><Typography variant="caption">BY MARKET</Typography></div></MenuItem>
            <MenuItem value={"location"}><div style={{padding: "5px 15px 0px 20px"}}><Typography variant="caption">BY LOCATION</Typography></div></MenuItem>
          </Select>          
          <Select
            multiple
            value={selectedMarkets}
            onChange={handleMarketChange}
            input={darkMode ? <StyledInput style={{minWidth: 200, maxWidth: 350}} /> : <StyledInputLT style={{minWidth: 200, maxWidth: 350}}/>}
            MenuProps={{
              anchorOrigin: {vertical: "bottom", horizontal: "left"},
              transformOrigin: {vertical: "top", horizontal: "left"},
              getContentAnchorEl: null
            }}
            renderValue={() => (                            
              selectedMarkets.length === checkList.length ?
              <div style={{padding: "5px 0px 0px 20px"}}>
                <Typography variant="caption">{`ALL ${locType.toUpperCase()}S`}</Typography>
              </div>
              :
              <div style={{padding: "5px 0px 0px 20px"}}>              
                <Typography variant="caption">{selectedMarkets.filter(item => item !== "ALL").length} {locType.toUpperCase()}S</Typography>
              </div>
            )}
          >
              {renderMarketSelectOptions()}
          </Select>
          <div className="roi-datepicker">
            <Menu
              anchorEl={anchor}
              open={mailingTypeOpen}
              onClose={handleMailTypeMenuClose}
              getContentAnchorEl={null}
              anchorOrigin={{vertical: "bottom", horizontal: "left"}}
              transformOrigin={{vertical: "top", horizontal: "left"}}
            >
              <MenuItem onClick={changeMailingType} data-my-value={"all"}><Typography variant="caption">ALL MAILINGS</Typography></MenuItem>
              <MenuItem onClick={changeMailingType} data-my-value={"complete"}><Typography variant="caption">COMPLETED MAILINGS</Typography></MenuItem>
            </Menu>

            {usr.roi_all_mailings_toggle === 0 ?
              <Typography variant="caption" style={{color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>SHOWING <span style={{fontWeight: "bold"}}>{mailingType.toUpperCase()} MAILINGS</span> FROM:</Typography>
            :            
              <Typography variant="caption" style={{color: `${darkMode ? "#fff" : "#6e6e6e"}`}}>SHOWING <span onClick={handleMailTypeMenu} className="roi-toggle">{mailingType.toUpperCase()} MAILINGS</span> FROM:</Typography>           
            }
            <div style={{width: "100%", marginTop: "5px"}}>
              <DayPicker 
                startDate={dates.minyearmo}
                endDate={dates.maxyearmo}                
                maxSliderValue={days}
                handleDateRange={handleDateChange}
                handleSliderDateChange={handleSliderChange}
                restoreHidden={true}
                dark={darkMode}
              />
            </div>
          </div>
        </div>
      </div>            

      <div style={selectedRoiData.length > 0 ? selectedRoiData[0].Data_Overall[0].HO_Count > 7500 ? {display: "none"} : {marginTop: "25px", marginBottom: "25px"} : {}}>
        <div className="holdout-warning">
          <div style={{margin: "1em", display: "inline-flex", alignItems: "center"}}>
              <Warning style={{color: "#de9f10"}}/>
              <Typography style={{fontWeight: "bold", color: "#fff"}}>
                Due to the low holdout quantity, <span style={{color: "#ff7d7d"}}>the incremental metrics may not be statistically significant</span>
              </Typography>
          </div>
        </div>
      </div>
      
      <br/>

      <div>

      </div>
      
      <Stats data={getStatsData()} dark={darkMode}/>
      <br/>
      {renderRoiTables()}        
    </div>
  )
}

export default RoiMain